import {
  faArrowDownWideShort,
  faArrowsUpDown,
  faBarsProgress,
  faCircleInfo,
  faClockFour,
  faCreditCard,
  faDesktop,
  faFileInvoiceDollar,
  faPersonMilitaryPointing,
  faSignal,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { reportsmenu } from "assets/icons/icons";
import { PicCenterOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const SubMenu = () => {
  const navigate = useNavigate();
  const data = [
    {
      icon: (
        <svg
          className="w-[17px]"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.349376 5.18642L7.68971 0L15.0679 5.18642H0.349376ZM13.3169 10.0574L13.1485 9.28804C13.871 9.42223 15.0297 10.8878 15.4044 11.5542C15.5957 11.8942 15.7632 12.269 15.9 12.6878C16.1735 13.7013 15.9104 14.6494 14.8066 14.8702C14.115 15.0091 12.8253 15.0187 12.0985 14.981C11.3163 14.9412 10.1066 14.9421 9.79034 14.1422C9.28065 12.8513 10.2147 11.3135 11.0669 10.3719C11.1794 10.248 11.2957 10.1328 11.415 10.026C11.725 9.75446 12.0594 9.43189 12.4585 9.298L12.0728 10.0129L12.6328 9.2734H12.9272L13.3169 10.0574ZM12.9566 10.6674V10.8838C13.0997 10.899 13.2228 10.9283 13.325 10.9719C13.4278 11.0161 13.5169 11.0824 13.5935 11.1721C13.6538 11.2403 13.7003 11.3104 13.7332 11.382C13.766 11.4545 13.7825 11.5199 13.7825 11.58C13.7825 11.6469 13.7579 11.7052 13.7091 11.7534C13.66 11.802 13.601 11.8266 13.5313 11.8266C13.3997 11.8266 13.3141 11.7556 13.2757 11.6142C13.231 11.4477 13.1247 11.3365 12.9566 11.2817V12.1137C13.1222 12.1588 13.255 12.2006 13.3532 12.2379C13.4516 12.275 13.54 12.3288 13.6175 12.3998C13.7004 12.473 13.7647 12.5608 13.81 12.6626C13.8544 12.7651 13.8769 12.8762 13.8769 12.9976C13.8769 13.1499 13.8416 13.2919 13.7697 13.4242C13.6975 13.5575 13.5922 13.6652 13.4532 13.7499C13.3132 13.834 13.1482 13.8838 12.9566 13.8994V14.3975C12.9566 14.476 12.9488 14.5336 12.9332 14.5697C12.9178 14.6058 12.8844 14.6236 12.8316 14.6236C12.7838 14.6236 12.7503 14.6093 12.7303 14.58C12.711 14.5504 12.7016 14.5047 12.7016 14.4433V13.9034C12.5453 13.8866 12.4085 13.8495 12.2913 13.7935C12.1741 13.7378 12.076 13.668 11.9978 13.5846C11.92 13.5008 11.8616 13.4139 11.8247 13.3246C11.7869 13.2346 11.7685 13.1459 11.7685 13.059C11.7685 12.9958 11.7932 12.9376 11.8438 12.8865C11.8938 12.8354 11.9563 12.8093 12.031 12.8093C12.0913 12.8093 12.1419 12.823 12.1835 12.851C12.2247 12.879 12.2535 12.9186 12.27 12.969C12.3057 13.0783 12.3372 13.1624 12.3638 13.2203C12.3913 13.2782 12.4316 13.3314 12.4857 13.3794C12.5397 13.427 12.6119 13.4638 12.7016 13.4893V12.5596C12.5219 12.5097 12.3725 12.4552 12.2522 12.3945C12.1316 12.3335 12.0335 12.2476 11.9591 12.1358C11.8844 12.0237 11.8466 11.8798 11.8466 11.7036C11.8466 11.4744 11.92 11.2861 12.0666 11.1397C12.2132 10.9931 12.4247 10.9078 12.7016 10.8838V10.6717C12.7016 10.5597 12.7441 10.5036 12.8282 10.5036C12.9141 10.5036 12.9566 10.5584 12.9566 10.6674ZM12.7016 12.0396V11.2736C12.5891 11.3072 12.5016 11.3508 12.4385 11.4053C12.3753 11.4598 12.3438 11.5433 12.3438 11.6538C12.3438 11.7587 12.3735 11.8387 12.4322 11.8926C12.4913 11.9468 12.581 11.9957 12.7016 12.0396ZM12.9566 12.6333V13.5095C13.0913 13.4831 13.1957 13.4292 13.2694 13.3479C13.3428 13.266 13.3797 13.1717 13.3797 13.0633C13.3797 12.9472 13.3441 12.8578 13.2722 12.7943C13.201 12.7308 13.0953 12.6769 12.9566 12.6333ZM12.2235 8.1886C12.096 7.81434 11.981 7.4351 11.8844 7.05025C12.2453 6.65544 13.6419 6.70806 14.0432 7.04434L13.6716 7.92488C13.8716 7.66333 13.9388 7.55591 14.0582 7.40988C14.1079 7.44257 14.1554 7.47931 14.1997 7.51948C14.3054 7.61507 14.3997 7.72031 14.4191 7.86696C14.4313 7.96224 14.4038 8.05939 14.3191 8.15809L13.4657 9.14792C13.3563 9.12986 13.2488 9.10402 13.1447 9.06697C13.1932 8.95363 13.2516 8.82877 13.2997 8.71543L12.9891 9.04953C12.666 8.98134 12.4057 9.02182 12.1632 9.14979L11.2982 8.11512C11.2469 8.05378 11.2238 7.99182 11.2238 7.93048C11.2247 7.68014 11.5985 7.46468 11.7947 7.38279L12.2235 8.1886ZM0 12.7548H0.853752V11.9655H1.30157V11.5887H1.78344V7.0708H0.79844V5.98818H12.2794C11.8888 6.06229 11.5338 6.20988 11.2994 6.43997C11.1908 6.5437 11.1118 6.67423 11.0703 6.81828C10.9722 6.88242 10.8747 6.95715 10.7882 7.03998L10.7569 7.0708H10.2632V10.0073C9.77409 10.5849 9.28503 11.3293 9.01596 12.124C8.85502 12.5991 8.77159 13.0914 8.80627 13.5815H0V12.7548ZM13.5544 5.98818H14.5797V6.39514C14.3429 6.19991 13.9641 6.06073 13.5544 5.98818ZM4.07907 11.9655H4.6347V11.5887H5.11658V7.0708H3.5972V11.5887H4.07907V11.9655ZM7.4119 11.9655H7.96877V11.5887H8.4494V7.0708H6.93002V11.5887H7.4119V11.9655ZM5.21783 3.87837L7.70096 1.98029L10.1978 3.87837H5.21783Z"
            fill={"#000"}
            fill-opacity="1"
          />
        </svg>
      ),
      title: "Financial Data",
      navigate: "/backend/finance-detailed-report",
    },
    {
      icon: (
        <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ color: "#000" }} />
      ),
      title: "Invoices vs Expenses",
      navigate: "/backend/finance-summary",
    },
    {
      icon: <FontAwesomeIcon icon={faCircleInfo} style={{ color: "#000" }} />,
      title: "Aged debtors",
      navigate: "/backend/aged-debtors",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={faArrowDownWideShort}
          style={{ color: "#000" }}
        />
      ),
      title: "Income",
      navigate: "/backend/expense-reports",
    },
    {
      icon: <FontAwesomeIcon icon={faArrowsUpDown} style={{ color: "#000" }} />,
      title: "Profit and loss",
      navigate: "/backend/profit-loss",
    },
    {
      icon: <FontAwesomeIcon icon={faDesktop} style={{ color: "#000" }} />,
      title: "Finance Monitor",
      navigate: "/backend/finance-monitor",
    },
    {
      icon: <FontAwesomeIcon icon={faSignal} style={{ color: "#000" }} />,
      title: "Activities",
      navigate: "/backend/summary",
    },
    {
      icon: (
        <svg
          className="w-[17px]"
          viewBox="0 0 13 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.2433 2.92575C5.0026 2.21129 4.78411 1.48932 4.59604 0.757226L4.58719 0.722561L4.54958 0.573572C4.74715 0.356049 5.06014 0.23266 5.33737 0.155294C6.48642 -0.162474 8.33219 0.0244346 8.96629 0.560821L8.20579 2.38056C8.61476 1.83983 8.75218 1.61782 8.99621 1.31659C9.09857 1.38433 9.19552 1.45999 9.28621 1.54288C9.50252 1.73995 9.69568 1.95774 9.73481 2.26129C9.76015 2.4582 9.70419 2.65819 9.53014 2.86273L7.7852 4.90796C7.5606 4.87087 7.34109 4.81665 7.12817 4.74045C7.2296 4.49739 7.34185 4.25812 7.44542 4.01386L6.8101 4.70435C6.14832 4.56386 5.61618 4.64771 5.1202 4.91165L3.35057 2.77434C3.24549 2.64687 3.19761 2.51946 3.19804 2.39195C3.20711 2.0457 3.51077 1.77535 3.77215 1.5898L3.77423 1.58837C3.98124 1.44277 4.20323 1.32878 4.36593 1.26071L5.2433 2.92575ZM7.02651 10.5442C7.01619 10.4265 6.96923 10.3358 6.88572 10.2698C6.82795 10.2242 6.75266 10.1944 6.66014 10.1806V10.8632L6.82844 10.9017C6.98857 10.9369 7.13078 10.9833 7.25444 11.0418C7.37738 11.1003 7.48079 11.1707 7.56502 11.2516C7.64769 11.3299 7.71293 11.425 7.75643 11.5305C7.79952 11.6361 7.82189 11.7546 7.82338 11.8849C7.82189 12.0918 7.76986 12.2686 7.66777 12.4171C7.56502 12.5647 7.41757 12.6786 7.22541 12.7574C7.06505 12.8233 6.87648 12.8614 6.66014 12.872V13.2422H6.39944V12.8717C6.1822 12.8605 5.98932 12.8209 5.82084 12.752C5.61825 12.6704 5.46113 12.546 5.34938 12.3789C5.23696 12.2117 5.17959 12.0004 5.17658 11.7448H5.92884C5.93474 11.8497 5.96312 11.9382 6.01215 12.0079C6.0621 12.0784 6.13063 12.1315 6.21774 12.1676C6.27311 12.1907 6.33365 12.2063 6.39944 12.2148V11.4943L6.16633 11.4398C5.88489 11.3746 5.66372 11.2696 5.50132 11.1243C5.33971 10.9789 5.2593 10.7824 5.26006 10.5344C5.2593 10.3321 5.31368 10.1545 5.42243 10.0023C5.53112 9.85017 5.68154 9.73172 5.87446 9.64629C6.03181 9.57712 6.20655 9.53602 6.39944 9.52317V9.15463H6.66014V9.52257C6.85896 9.53482 7.03546 9.57639 7.18888 9.64705C7.37514 9.73325 7.51883 9.85319 7.62164 10.0075C7.72439 10.162 7.77642 10.3403 7.77877 10.5442H7.02651ZM6.39944 10.1806C6.35401 10.1871 6.31319 10.1975 6.27736 10.2114C6.20956 10.2383 6.15894 10.2751 6.12539 10.3208C6.0912 10.3672 6.07401 10.4205 6.07253 10.4797C6.07104 10.5292 6.08068 10.5719 6.10239 10.6094C6.1239 10.6469 6.15594 10.679 6.19761 10.7075C6.23939 10.736 6.29003 10.7608 6.34883 10.7818C6.36516 10.7875 6.38209 10.7931 6.39944 10.7986V10.1806ZM6.66014 12.2127C6.70861 12.2056 6.75272 12.1943 6.79268 12.1787C6.86715 12.1503 6.92453 12.1106 6.96471 12.0596C7.005 12.0079 7.02575 11.9495 7.02651 11.8835C7.02575 11.822 7.00642 11.7688 6.96923 11.7245C6.93195 11.6804 6.8753 11.6421 6.79868 11.6099C6.75342 11.5908 6.70717 11.5743 6.66014 11.5603V12.2127ZM3.55297 9.71678C4.39371 8.12745 6.35533 7.52485 7.93463 8.37094C9.51404 9.21692 10.1128 11.191 9.27209 12.7804C8.43144 14.3698 6.46982 14.9724 4.89045 14.1264C3.31105 13.2803 2.71232 11.3062 3.55297 9.71678ZM7.51098 6.78721L7.16562 5.19771C8.64485 5.47457 11.0158 8.50269 11.782 9.87952C12.173 10.5823 12.5155 11.3564 12.7959 12.2219C13.3545 14.3165 12.8164 16.2759 10.5586 16.7323C9.14393 17.0184 6.50562 17.0386 5.01778 16.9611C3.41828 16.8779 0.943129 16.8804 0.296527 15.2278C-0.747039 12.5602 1.16495 9.38225 2.90821 7.43722C3.13766 7.18125 3.37486 6.94274 3.62028 6.72256C4.09382 6.30335 4.55469 5.86701 5.09469 5.53324L5.09535 5.53291C5.29358 5.41161 5.49974 5.30788 5.71483 5.23151L5.71625 5.23101L5.75446 5.21776L4.96598 6.6952L5.87037 5.48865L6.11113 5.16746H6.71451L7.06845 5.88723L7.51098 6.78721Z"
            fill={"#000"}
            fill-opacity="1"
          />
        </svg>
      ),
      title: "Locations",
      navigate: "/backend/report",
    },
    {
      icon: <FontAwesomeIcon icon={faBarsProgress} style={{ color: "#000" }} />,
      title: "Languages",
      navigate: "/backend/languages",
    },
    {
      icon: <FontAwesomeIcon icon={faClockFour} style={{ color: "#000" }} />,
      title: "Industry",
      navigate: "/backend/languages",
    },
    {
      icon: <FontAwesomeIcon icon={faCreditCard} style={{ color: "#000" }} />,
      title: "Tax Report",
      navigate: "/backend/tax",
    },
  ];
  return (
    <div>
      <div className="flex items-center px-2 mb-5">
        <div className="w-10 flex justify-center">
          <img src={reportsmenu} alt="" />
        </div>
        <p className="text-primary text-xl ml-3">Insights</p>
      </div>
      {data.map((e, i) => {
        return (
          <div>
            {e.title === "Activities" && (
              <div className={`flex items-center px-2 pt-2`}>
                <div className="w-10 flex justify-center"></div>
                <p className="font-semibold ml-3">Customers</p>
              </div>
            )}
            {e.title === "Financial Data" && (
              <div className={`flex items-center px-2 mt-4`}>
                <div className="w-10 flex justify-center"></div>
                <p className="font-semibold ml-3">Finance</p>
              </div>
            )}
            <div
              key={i}
              className={`flex items-center py-3 hover:bg-themeGray-light cursor-pointer rounded-lg px-2`}
              onClick={() => e.navigate && navigate(e.navigate)}
            >
              <div className="w-10 flex justify-center">{e.icon}</div>
              <p className="text-sm ml-3">{e.title}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SubMenu;
